import React, { FunctionComponent } from "react";

import * as Icons from "../../assets/icons";

type IconProps = {
  iconName: string;
  className?: string;
  // All other props
  [x: string]: any;
};

export const Icon: FunctionComponent<IconProps> = ({
  className,
  iconName,
  ...rest
}) => {
  switch (iconName) {
    case "user":
      return <Icons.UserIcon className={className} />;
    case "rtabak_icon":
      return <Icons.RtabakIcon className={className} />;
    case "mobile_navigation_menu":
      return <Icons.MobileMenuIcon className={className} />;
    case "shopping_bag":
      return <Icons.ShoppingBag className={className} />;
    case "divisor_line":
      return <Icons.DivisorLine className={className} />;
    case "broken_chain":
      return <Icons.BrokenChainIcon className={className} />;
    case "hide":
      return <Icons.HideIcon className={className} />;
    case "unhide":
      return <Icons.UnhideIcon className={className} />;
    case "search_icon":
      return <Icons.SearchIcon className={className} />;
    case "search_admin":
      return <Icons.SearchAdmin className={className} />;
    case "rtabak_white_icon":
      return <Icons.RtabakWhiteIcon className={className} />;
    case "since_text_icon":
      return <Icons.SinceTextIcon className={className} />;
    case "mousse_icon":
      return <Icons.MousseIcon className={className} />;
    case "trash_icon":
      return <Icons.TrashIcon className={className} />;
    case "pdf_icon":
      return <Icons.PDFIcon className={className} />;
    case "right_arrow":
      return <Icons.RightArrow className={className} />;
    case "video_play":
      return <Icons.VideoPlay className={className} />;
    case "rtabak_grey_icon":
      return <Icons.RtabakGreyIcon className={className} />;
    case "trash_cart":
      return <Icons.TrashIconCart className={className} />;
    case "up_arrow":
      return <Icons.UpArrow className={className} />;
    case "down_arrow":
      return <Icons.DownArrow className={className} />;
    case "bottom-arrow":
      return <Icons.BottomArrow className={className} />;
    case "go-to-arrow":
      return <Icons.GotoArrow className={className} />;
    case "edit_icon":
      return <Icons.EditIcon className={className} />;
    case "edit_icon_admin":
      return <Icons.EditIconAdmin className={className} />;
    case "logout_icon":
      return <Icons.LogOutIcon className={className} />;
    case "edit-icon-squared":
      return <Icons.EditIconSquared className={className} />;
    case "ManufacturingIcon":
      return <Icons.ManufacturingIcon className={className} />;
    case "HighlightedIcon":
      return <Icons.HighlightedIcon className={className} />;
    case "ProductsIcon":
      return <Icons.ProductsIcon className={className} />;
    case "close_icon":
      return <Icons.CloseIcon className={className} />;
    case "alert_icon":
      return <Icons.AlertIcon className={className} />;
    case "tick_icon":
      return <Icons.TickIcon className={className} />;
    case "close_x_icon":
      return <Icons.CloseXIcon className={className} />;
    case "down_line":
      return <Icons.DownLine className={className} />;
    case "check_icon":
      return <Icons.CheckIcon className={className} />;
    case "wpp_icon":
      return <Icons.WppIcon className={className} />;
    default:
      return null;
  }
};
